import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import positionsListItemContainer from './positionsListItemContainer'
import './PositionsListItem.css'

export const PositionsListItem = ({
  active,
  filled,
  incumbent,
  onClick,
  position,
}) => {
  const itemClassNames = classNames("list-group-item list-group-item-action PositionsListItem", {
    "active": active,
  })

  return (
    <a
      className={itemClassNames}
      href={`/positions/${position.position_id}`}
      onClick={onClick}
      role="button"
    >
      <h6>{position.name}</h6>
      {position.level && <small>{position.level}</small>}
      <div>
        {filled && <span className="badge badge-info mr-1">filed</span>}
        {incumbent && <span className="badge badge-secondary">incumbent</span>}
      </div>
    </a>
  )
}

PositionsListItem.propTypes = {
  active: PropTypes.bool,
  filled: PropTypes.bool,
  incumbent: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  position: PropTypes.shape({
    level: PropTypes.string,
    name: PropTypes.string.isRequired,
  }).isRequired,
}

export default positionsListItemContainer(PositionsListItem)



// WEBPACK FOOTER //
// ./src/components/PositionsScene/PositionsList/PositionsListItem/PositionsListItem.js